import CatalogTableReport from './CatalogTableReport';
import { BILLCOM_BANK_CASH_RECON } from '../../consts/reports';

const BillcomBankCashReconReport = (props) => (
    <CatalogTableReport
        {...props}
        reportType={BILLCOM_BANK_CASH_RECON}
        title="Bill.com vs Bank Cash Reconciliation"
        description="Compare Bill.com payments with settled bank cash by day."
    />
);

export default BillcomBankCashReconReport;
